import { combineReducers } from 'redux'
import icons from './icons'
import tabs from './tabs'

export default combineReducers({
    icons, tabs
})
